import React, { Dispatch, SetStateAction } from 'react';
import { useSelector } from 'react-redux';
import { View } from 'react-native';

import ColorWrapper from '@styles/colors';
import AttachEntitiesListOP from '@components/operatorPanel/components/elements/AttachEntitiesListOP';
import RichTextEditor from './Editor';

import { scaleOP } from '@components/frame';
import { fontOP } from '@styles/fonts';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

import { ColorFunction } from '@styles/colors/types';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import {
  addOrUpdateImageDocument,
  selectCurrentImageDocumentContext,
  selectSelectedNote,
} from '../../../../../../reducers/v2/imageHandlingV2/imageHandlingV2.slice';

interface EditScreenProps {
  C: ColorFunction;
  setTouched: Dispatch<SetStateAction<boolean>>;
  setEditorValue: Dispatch<SetStateAction<string>>;
  links: NewLink[];
  setLinks: Dispatch<SetStateAction<NewLink[]>>;
}

export type NewLink = {
  scopeId: number;
  scopeReferenceId: number;
  scopeReferenceName?: string;
  isFavorite?: boolean;
  isSelected?: boolean;
};

const EditScreen: React.FC<EditScreenProps> = ({ C, setTouched, setEditorValue, links, setLinks }) => {
  const dispatch = useAppDispatch();

  const activeNote = useSelector(selectSelectedNote);
  const currentContext = useSelector(selectCurrentImageDocumentContext);

  const onAttachmentChange = (link?: NewLink) => {
    if (!link) {
      return;
    }

    setLinks((prev) => {
      const existingIdx = prev.findIndex((l) => l.scopeId === link.scopeId && l.scopeReferenceId === link.scopeReferenceId);

      if (existingIdx === -1) {
        return prev.concat(link);
      } else {
        return prev.filter((_, idx) => idx !== existingIdx);
      }
    });

    if (activeNote) {
      const links = [...activeNote.links];
      const existingIdx = links.findIndex((l) => l.scopeId === link.scopeId && l.scopeReferenceId === link.scopeReferenceId);

      if (existingIdx === -1) {
        links.push(link);
      } else {
        links.splice(existingIdx, 1);
      }

      dispatch(addOrUpdateImageDocument({ document: { ...activeNote, links }, imageContext: currentContext }));
    }
  };

  return (
    <View
      testID={TEST_IDS.operatorPanel.information.notes.editScreen}
      style={{ flex: 1, width: '100%', height: '100%', padding: scaleOP(15), backgroundColor: C('Background/Light/Panel [mobile]') }}
    >
      <AttachEntitiesListOP
        scale={scaleOP}
        font={fontOP}
        imageDocumentLinks={activeNote?.links?.length ? activeNote.links : links}
        selectedImageDocument={activeNote}
        onChange={onAttachmentChange}
      />
      <RichTextEditor activeNote={activeNote} setTouched={setTouched} onChange={setEditorValue} />
    </View>
  );
};

export default ColorWrapper(EditScreen);
